import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Tabs, Tooltip } from 'antd';
import VerificationCode from './VerificationCode';
import Password from './Password';
import ForgetPassword from './ForgetPassword';
import CodeVerify from './CodeVerify';
import QrAssistLogin from './QrAssistLogin';
import s from './style.m.less';
import { QuestionCircleOutlined } from '@ant-design/icons';
import InformationModal from '../CustomPage/qhb/InformationModal';
import { Display } from '@/components/Display/Display';
import { logo_isUse_map } from '@/utils/constants';
import ImageRender from '@/components/GrtImage/ImageRender';
import qrcodeLoginIcon from '@/assets/images/login/qrcode_login_icon.webp';
import formLoginIcon from '@/assets/images/login/form_login_icon.webp';
@inject('store')
@observer
class Home extends Component {
    onChange = (activeKey) => {
        const {
            store: { login }
        } = this.props;

        login.setActiveKey(activeKey);
    };
    onCancel = () => {
        window.location.reload();
    };
    render() {
        const {
            store: { login }
        } = this.props;

        return (
            <div
                className={s.app}
                style={{
                    backgroundImage: `url(${login.loginCustomConfig?.background_image || ''})`
                }}
            >
                <InformationModal onCancel={this.onCancel} closable={true} title={'完善注册信息'} tip={'请您先完善下方的信息，即可完成注册'}></InformationModal>
                <div className={s['content_box']}>
                    <div
                        className={s['content_left']}
                        style={{
                            backgroundImage: `url(${login.loginCustomConfig?.main_image || ''})`
                        }}
                    >
                        <div className={s['logo_part']}>
                            <Display show={login.loginCustomConfig?.login_checked === logo_isUse_map.SHOW}>
                                <ImageRender className={s['logo']} src={login.loginCustomConfig?.login_image || ''} alt="" />
                            </Display>
                            <div className={s['title']}>{login.loginCustomConfig?.title}</div>
                        </div>
                        <ImageRender className={s['content_splite_img']} src={require('@/assets/images/login/login_custon.webp')} alt="" />
                    </div>
                    <div className={s['content_right']}>
                        <div className={s.content}>
                            {login.mode === 'login' ? (
                                <div>
                                    <div
                                        className={`${s.login_qr_corner} ${s.login_qr_corner_active}`}
                                        onClick={() => login.toggleLoginAssistMode()}
                                    >
                                        <img
                                            className={s.login_qr_corner_icon}
                                            src={login.loginAssistMode === 'qr' ? formLoginIcon : qrcodeLoginIcon}
                                        />
                                    </div>
                                    <Card className={login.loginAssistMode === 'qr' ? s.login_card_qr : s.login_card_form}>
                                        {login.loginAssistMode !== 'qr' ? (
                                            <div className={s.login_head}>
                                                <h3 style={{ margin: '6px 0 12px', fontSize: '20px' }}>欢迎登录</h3>
                                            </div>
                                        ) : null}
                                        {login.loginAssistMode === 'qr' ? (
                                            <QrAssistLogin />
                                        ) : (
                                            <Tabs
                                                onChange={this.onChange}
                                                activeKey={login.activeKey}
                                                items={[
                                                    {
                                                        key: 'code',
                                                        label: '验证码登录',
                                                        children: <VerificationCode />
                                                    },
                                                    {
                                                        key: 'password',
                                                        label: (
                                                            <span>
                                                                密码登录
                                                                <Tooltip title="密码为8-16位，需要至少包含：大写字母、小写字母、数字、特殊符号中的四类，且不能为生日或简单键盘组合">
                                                                    <QuestionCircleOutlined style={{ fontSize: 18, lineHeight: '28px', marginLeft: '4px' }} />
                                                                </Tooltip>
                                                            </span>
                                                        ),
                                                        children: <Password />
                                                    }
                                                ]}
                                            />
                                        )}
                                    </Card>
                                </div>
                            ) : login.mode === 'codeVerify' ? (
                                //多因子 验证码校验
                                <Card>
                                    <CodeVerify />
                                </Card>
                            ) : (
                                <Card>
                                    <ForgetPassword />
                                </Card>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;
